import { render, staticRenderFns } from "./AdvertisementEdit.vue?vue&type=template&id=096ec474"
import script from "./AdvertisementEdit.vue?vue&type=script&lang=js"
export * from "./AdvertisementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports